import { ModelRule } from 'src/containers/ProjectDiagram/types/data';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 * * on {@link ModelRule} add `models`
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v31 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v31Projects(prevState.projects);
  }

  return nextState;
};

const v31Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (!project.diagram) {
      projectsById[projectId] = project;
      return;
    }

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          modelData: {
            ...project.diagram.model.modelData,
            rulesById: Object.entries(
              project.diagram.model.modelData.rulesById
            ).reduce<Record<string, ModelRule>>((acc, [ruleId, rule]) => {
              acc[ruleId] = {
                ...rule,
                models: [project.targetModelId],
              };
              return acc;
            }, {}),
          },
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
